import { Link } from 'react-router-dom';
import React from 'react';
import { routes, subRoutes } from '../../../utils/constants/routes';

const generateFields = (numberOfFields) => {
  const temp = [];
  for (let i = 1; i <= numberOfFields; i += 1) {
    temp.push(`value${i}`);
  }
  return temp;
};

const dashboardReducer = (state, { type, payload }) => {
  const generateData = (f) => {
    return f.map((d) => ({
      item: d,
      count: payload?.[d],
      percent: payload?.[d] / payload?.total
    }));
  };

  let fields;
  switch (type) {
    case 'transformationRate':
      fields = generateFields(2);
      return {
        fields,
        value1: payload?.value1,
        value2: payload?.value2,
        rate: payload?.rate
          ? Math.round((payload?.rate + Number.EPSILON) * 10) / 10
          : 0,
        data: generateData(fields),
        formatter: (value, k) => (
          <Link
            to={
              k === 'value1'
                ? `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_SAVED}`
                : `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}`
            }
          >
            {value}
          </Link>
        )
      };
    case 'unpaidRate':
      fields = generateFields(3);
      return {
        fields,
        value1: payload?.value1,
        value2: payload?.value2,
        value3: payload?.value3,
        rate: payload?.rate
          ? Math.round((payload?.rate + Number.EPSILON) * 10) / 10
          : 0,
        data: generateData(fields),
        formatter: (value, k) => {
          let search = 'f=status=UNPAID_1,UNPAID_2__';
          if (k === 'value2') search = 'f=status=FORMAL_NOTICE__';
          if (k === 'value3') search = 'f=status=TERMINATED_NON_PAYMENT__';
          return (
            <Link
              to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}?${search}`}
            >
              {value}
            </Link>
          );
        }
      };
    case 'incompleteFiles':
      fields = generateFields(2);
      return {
        fields,
        value1: payload?.value1,
        value2: payload?.value2,
        rate: payload?.rate
          ? Math.round((payload?.rate + Number.EPSILON) * 10) / 10
          : 0,
        data: generateData(fields)
      };
    case 'claimsRate':
      fields = generateFields(3);
      return {
        fields,
        value1: payload?.value1,
        value2: payload?.value2,
        value3: payload?.value3,
        rate: payload?.rate
          ? Math.round((payload?.rate + Number.EPSILON) * 10) / 10
          : 0,
        data: generateData(fields)
      };
    default:
      return {};
  }
};

export { dashboardReducer };
